<template>
  <tr class="row tariff-detail-row" v-if="showDiscountCondition">
    <td class="text tariff-detail-text contract">
      <slot name="txtCurrentTariffDiscount">{{ description }} <a v-if="isPromoCode===true" class="info-link-icon current-tariff-row" @click="openCouponRedeemedModal"></a><br>
        <span class="promo-expiry-date" v-if="!isPermanentDate(expirationDate)"><slot name="txtValidUntil">gültig bis </slot>{{ expirationDateFormatted }}</span>
        <span class="promo-expiry-date " v-else>
            <slot name="txtPromoPermanent">Dauerhaft gültig</slot>
        </span>
      </slot>
    </td>
    <td class="value tariff-detail-value">{{ price(discount) }}</td>
    <CouponRedeemedModal
        :show.sync="showCouponRedeemedModal"
        :shoppingCartWasOpen = "shoppingCartWasOpen"
        :showDelete=false
        :showCouponRedeemedModal.sync="showCouponRedeemedModal"
    >
      <template slot="couponModalInfo"><slot :name="couponRedeemedModalInfo"></slot></template>
      <template slot="txtCouponRedeemModalTitle"><slot name="txtCouponRedeemModalTitle"></slot></template>
      <template slot="txtCouponRedeemModalBeforeInfoBox"><slot name="txtCouponRedeemModalBeforeInfoBox"></slot></template>
    </CouponRedeemedModal>
  </tr>
</template>

<script>
import promoContext from '@/mixins/promoContext'
import price from '@/mixins/formatters/price'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import useFeature from '@/mixins/useFeature'
import CouponRedeemedModal from '@/components/modal/coupon/CouponRedeemedModal.vue'
import { mapActions } from 'vuex'
import date from '@/mixins/validators/date'

export default {
  name: 'PromoCurrentTariffDiscount',
  data () {
    return {
      showDiscount: false,
      expirationDateFormatted: '',
      showExpirationDate: false,
      showCouponRedeemedModal: false,
      shoppingCartWasOpen: false,
      couponRedeemedModalInfo: ''
    }
  },
  components: {
    CouponRedeemedModal
  },
  mixins: [
    promoContext,
    useFeature('showFeaturePromotion'),
    price,
    dateFormatter,
    date
  ],
  props: {
    default: {
      required: true,
      type: Boolean
    },
    description: {
      required: false,
      type: String
    },
    discount: {
      required: true,
      type: Number
    },
    expirationDate: {
      required: false,
      type: String
    },
    isPromoCode: {
      type: Boolean,
      default: false
    },
    promoId: {
      required: true,
      type: Number
    }
  },
  mounted () {
    if (typeof this.discount === 'number') {
      this.showDiscount = true
      this.expirationDateFormatted = this.dateFormatter(this.expirationDate)
      if (this.expirationDateFormatted !== false) {
        this.showExpirationDate = true
      }
    }
  },
  computed: {
    showDiscountCondition () {
      return this.showDiscount && this.showFeaturePromotion
    }
  },
  methods: {
    ...mapActions('promotion/promoCode', [
      'removePromoCode',
      'getSlotsIdForVoucherPromo'
    ]),
    openCouponRedeemedModal () {
      this.showCouponRedeemedModal = true
      if (this.promoId !== null && typeof this.promoId === 'number') {
        this.getSlotsIdForVoucherPromo({ promotionId: this.promoId }).then((voucherPromotion) => {
          this.couponRedeemedModalInfo = 'txtCouponRedeemedModal' + voucherPromotion
        })
      }
    }
  }
}
</script>
